export default __webpack_public_path__ + "static/media/pending-activities-icon.28761590.svg";